import { EditTemplateMarketingMenuViewModel } from '../edit-template-marketing-menu-view-model';
import { Injectable, Injector, NgZone } from '@angular/core';
import { TemplateDomainModel } from '../../../../../../domainModels/template-domain-model';
import { LocationDomainModel } from '../../../../../../domainModels/location-domain-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditPlaylistMenuViewModel } from '../../../../../menu/components/edit-menu/edit-marketing-menu/edit-playlist-menu/edit-playlist-menu-view-model';
import { WebSocketService } from '../../../../../../services/web-socket.service';
import { ToastService } from '../../../../../../modules/toasts/service/toast.service';
import { filter } from 'rxjs/operators';

@Injectable()
export class EditTemplateMarketingPlaylistMenuViewModel extends EditTemplateMarketingMenuViewModel {
  constructor(
    protected override editMenuViewModel: EditPlaylistMenuViewModel,
    templateDomainModel: TemplateDomainModel,
    locationDomainModel: LocationDomainModel,
    toastService: ToastService,
    webSocketService: WebSocketService,
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector
  ) {
    super(
      editMenuViewModel,
      templateDomainModel,
      locationDomainModel,
      toastService,
      webSocketService,
      ngZone,
      ngbModal,
      injector
    );
  }

  override listenForFetchMenuTemplateCommand(): void {
    this.reloadTemplateMessages$
      .pipe(filter(({ message, menuTemplate }) => message?.isAboutThis(menuTemplate)))
      .subscribeWhileAlive({
        owner: this,
        next: ({ message, menuTemplate, userId }) => {
          this.editMenuViewModel.handleReloadPlaylistMenuCommand(message, menuTemplate, userId);
        }
      });
  }
}
